export async function uploadImageToGitHub(file) {
  const token = process.env.REACT_APP_GITHUB_TOKEN;
  const owner = process.env.REACT_APP_GITHUB_OWNER;
  const repo = process.env.REACT_APP_GITHUB_REPO;

  const fileName = `post_${Date.now()}_${file.name}`;
  const path = `posts/${fileName}`;

  // Convert image to base64
  const reader = new FileReader();

  return new Promise((resolve, reject) => {
    reader.onload = async () => {
      const base64Content = reader.result.split(",")[1];

      try {
        const response = await fetch(
          `https://api.github.com/repos/${owner}/${repo}/contents/${path}`,
          {
            method: "PUT",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              message: `Upload ${fileName}`,
              content: base64Content,
            }),
          }
        );

        if (!response.ok) {
          throw new Error("GitHub upload failed");
        }

        // const data = await response.json();

        // RAW GitHub URL
        const rawUrl = `https://raw.githubusercontent.com/${owner}/${repo}/main/${path}`;

        resolve(rawUrl);
      } catch (err) {
        reject(err);
      }
    };

    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
